import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useRestaurant } from "../context/RestaurantContext";
import logo from "../assets/images/logo.png";
import location from "../assets/images/location.png";
import location2 from "../assets/images/location-modal/location.png";
import add from "../assets/images/location-modal/add.png";
import briefcase from "../assets/images/location-modal/briefcase.png";
import home from "../assets/images/location-modal/home.png";
import arrow from "../assets/images/location-modal/arrow-right.png";
import check from "../assets/images/location-modal/check.png";
import cancel from "../assets/images/navbar/cancel.png";
import dish from "../assets/images/navbar/dish.png";
import house from "../assets/images/navbar/house.png";
import user from "../assets/images/navbar/user.png";
import bell from "../assets/images/navbar/bell.png";
import cart from "../assets/images/navbar/cart.png";
import whitebell from "../assets/images/navbar/white-bell.png";
import whitecart from "../assets/images/navbar/white-cart.png";
import whitedish from "../assets/images/navbar/white-dish.png";
import Profile from "./Profile";
import { useNotifications } from "../context/NotificationContext";

const Navbar = () => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const { restaurantProfile, isLoadingProfile } = useRestaurant();
  const { unreadCount } = useNotifications();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [isLocationOpen, setIsLocationOpen] = useState<boolean>(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState<boolean>(false);
  // Determine active icon based on current pathname
  const isActive = (path: string) => currentLocation.pathname === path;

  const searchedItem = [
    "Dosa",
    "Burger",
    "Asian Kitchen",
    "Domino’s Pizza",
    "South Indian",
  ];

  return (
    <nav className="hidden md:block fixed top-0 left-0 right-0 z-[1000] p-0 bg-white dark:bg-gray-900 border-b dark:border-gray-700 transition-colors">
      <div className="max-w-[1400px] mx-auto px-5 py-3 flex justify-between items-center gap-5 flex-wrap md:flex-nowrap">
        <div className="flex items-center gap-2">
          {/* Logo */}
          <Link to="/" className="">
            <img src={logo} alt="Duddus Logo" className="w-[146px] h-12" />
          </Link>
          <div className="flex w-[240px] items-center relative">
            <div className="flex w-12 h-12 p-2.5 justify-center items-center gap-2.5 flex-shrink-0 rounded-full bg-white/25">
              <img
                src={location}
                alt="location"
                // onClick={() => setIsLocationOpen(!isLocationOpen)}
                className="cursor-pointer"
              />
            </div>
            <div className="flex flex-col">
              <div className="flex items-center">
                <span className="text-gray-900 dark:text-gray-200 text-center text-base font-medium leading-[150%]">
                  {isLoadingProfile ? "Loading..." : (restaurantProfile?.businessName || "Restaurant Name")}
                </span>
                <img
                  src={arrow}
                  alt="arrow"
                  className="h-[20px] w-[20px] rotate-90"
                />
              </div>

              <span className="w-[160px] overflow-hidden text-gray-600 dark:text-gray-400 text-sm font-normal leading-[160%] truncate">
                {isLoadingProfile ? "Loading..." : (restaurantProfile?.location?.address || "Address")}
              </span>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div
          className={`flex items-center gap-[17px] ${isMenuOpen ? "flex" : "hidden"} md:flex md:order-3`}
        >
          {/* Navigation Links */}
          <div
            className={`flex items-center gap-[17px] ${isMenuOpen ? "flex" : "hidden"} md:flex md:order-3`}
          >
            <div
              className="h-[48px] w-[48px] rounded-full cursor-pointer flex items-center justify-center border-2 relative"
              style={{
                backgroundColor: isActive("/notification")
                  ? "#FF8A00"
                  : "transparent",
              }}
              onClick={() => {
                navigate("/notification");
              }}
            >
              <img
                src={isActive("/notification") ? whitebell : bell}
                alt="Notifications"
                className={`${isActive("/notification") ? "h-[22px] w-[22px]" : "h-[48px] w-[48px]"}`}
              />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF8A00] text-white text-[10px] font-semibold flex items-center justify-center">
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </div>
            <div
              className="h-[48px] w-[48px] rounded-full cursor-pointer flex items-center justify-center border-2"
              style={{
                backgroundColor: isActive("/dish") ? "#FF8A00" : "transparent",
              }}
              onClick={() => {
                navigate("/dish");
              }}
            >
              <img
                src={isActive("/dish") ? whitedish : dish}
                alt="cuisines"
                className={`${isActive("/dish") ? "h-[22px] w-[22px]" : "h-[22px] w-[22px]"}`}
              />
            </div>
            <div
              className="h-[48px] w-[48px] rounded-full cursor-pointer flex items-center justify-center border-2"
              style={{
                backgroundColor: isActive("/orders")
                  ? "#FF8A00"
                  : "transparent",
              }}
              onClick={() => {
                navigate("/orders");
              }}
            >
              <img
                src={isActive("/orders") ? whitecart : cart}
                alt="Cart"
                className={`${isActive("/orders") ? "h-[22px] w-[22px]" : "h-[48px] w-[48px]"}`}
              />
            </div>
            <div
              className="h-[48px] w-[48px] rounded-full cursor-pointer flex items-center justify-center border-2"
              onClick={() => {
                setIsUserModalOpen(true);
              }}
            >
              <img src={house} alt="house" className="h-[22px] w-[22px]" />
            </div>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="hidden md:hidden bg-none border-none text-gray-900 text-2xl cursor-pointer p-1"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          ☰
        </button>
      </div>

      {isLocationOpen && (
        <div
          className="fixed inset-0 z-50"
          onClick={() => setIsLocationOpen(false)}
        >
          <div
            className="absolute left-[217px] top-[33px] mt-2 w-[430px] bg-white dark:bg-gray-800 rounded-[20px] shadow-[0_8px_17px_0_rgba(0,0,0,0.20)] p-5 space-y-5"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Use Current Location */}
            <div className="flex justify-between items-center border dark:border-gray-700 rounded-[16px] p-[12px] cursor-pointer">
              <div className="flex items-center gap-3">
                <img
                  src={location2}
                  alt="location"
                  className="h-[16px] w-[16px]"
                />
                <span className="text-purple-700 font-medium">
                  Use Current location
                </span>
              </div>
              <img src={arrow} alt="arrow" className="h-[18px] w-[18px]" />
            </div>

            {/* Address List Card */}
            <div className="border dark:border-gray-700 rounded-[16px] p-[12px] space-y-4">
              {/* HOME */}
              <div className="flex justify-between items-center">
                <div className="flex gap-3 items-center">
                  <img src={home} alt="home" className="h-[20px] w-[20px]" />
                  <div>
                    <p className="text-[14px] font-medium text-black dark:text-gray-200">HOME</p>
                    <p className="w-[250px] overflow-hidden text-ellipsis whitespace-nowrap text-[#6A6A6A] dark:text-gray-400 font-Urbanist text-[14px] font-normal leading-[140%]">
                      {restaurantProfile?.location?.address || "No address available"}
                    </p>
                  </div>
                </div>
                <img src={check} alt="" className="h-[24px] w-[24px]" />
              </div>

              <div className="border-t border-dashed dark:border-gray-700"></div>

              {/* WORK */}
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <img
                    src={briefcase}
                    alt="briefcase"
                    className="h-[20px] w-[20px]"
                  />
                  <div>
                    <p className="text-[14px] font-medium text-black dark:text-gray-200">WORK</p>
                    <p className="w-[250px] overflow-hidden text-ellipsis whitespace-nowrap text-[#6A6A6A] dark:text-gray-400 font-Urbanist text-[14px] font-normal leading-[140%]">
                      {restaurantProfile?.location?.address || "No address available"}
                    </p>
                  </div>
                </div>
                <button className="text-[#FF8A00] font-Urbanist text-[10px] font-semibold leading-[140%]">
                  SET DEFAULT
                </button>
              </div>

              <div className="border-t border-dashed"></div>

              {/* OTHER */}
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                  <img
                    src={location2}
                    alt="location"
                    className="h-[20px] w-[20px]"
                  />
                  <div>
                    <p className="text-[14px] font-medium text-black dark:text-gray-200">OTHER</p>
                    <p className="w-[250px] overflow-hidden text-ellipsis whitespace-nowrap text-[#6A6A6A] dark:text-gray-400 font-Urbanist text-[14px] font-normal leading-[140%]">
                      {restaurantProfile?.location?.address || "No address available"}
                    </p>
                  </div>
                </div>
                <button className="text-[#FF8A00] font-Urbanist text-[10px] font-semibold leading-[140%]">
                  SET DEFAULT
                </button>
              </div>
            </div>

            {/* Add New Address */}
            <div className="flex justify-between items-center border dark:border-gray-700 rounded-[16px] px-4 py-4 cursor-pointer">
              <div className="flex items-center gap-3">
                <img src={add} alt="add" className="h-[16px] w-[16px]" />
                <span className="text-[#7604A5] font-Urbanist text-[16px] font-medium leading-[160%]">
                  Add New Address
                </span>
              </div>
              <img src={arrow} alt="arrow" className="h-[18px] w-[18px]" />
            </div>

            {/* Save Button */}
            <button className="w-full text-center flex justify-center items-center self-stretch py-3 pr-3 pl-6 rounded-[150px] bg-[#7604A5] text-white font-Urbanist text-[16px] font-medium leading-[160%]">
              Save
            </button>
          </div>
        </div>
      )}

      {searchQuery && (
        <div className="absolute left-[42%] top-[59px] z-[999] w-[390px] bg-white rounded-[10px] shadow-[0_8px_17px_0_rgba(0,0,0,0.20)] p-4 space-y-5">
          <div>
            <div className="flex justify-between items-center">
              <p className="text-[#6A6A6A] font-Urbanist text-[12px] font-medium leading-[140%]">
                Recent Searches
              </p>
              <div className="flex gap-[4px]">
                <img src={cancel} alt="cancel" className="h-[16px] w-[16px]" />
                <p
                  className="text-[#FF8A00] font-Urbanist text-[12px] font-medium leading-[140%] cursor-pointer"
                  onClick={() => setSearchQuery("")}
                >
                  Clear
                </p>
              </div>
            </div>
            {searchedItem.map((item, index) => (
              <div
                key={index}
                className="flex items-center py-3 px-[6px] gap-2 self-stretch border-b"
              >
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* User Modal - Slide from Right */}
      {isUserModalOpen && <Profile setIsUserModalOpen={setIsUserModalOpen} />}
    </nav>
  );
};

export default Navbar;
